import { render, staticRenderFns } from "./select.generic.vue?vue&type=template&id=7d636c8c&"
import script from "./select.generic.vue?vue&type=script&lang=js&"
export * from "./select.generic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports